import { Modal } from "@mui/material";
import styled from "styled-components";
import ButtonComponent from "../button";
import IconDelete from "../../assets/images/icon-delete-2.svg"

const Container = styled.div`
    width: calc(480px - 72px);
    max-height: calc(100vh - 160px);
    padding: 36px;
    border-radius: 16px;
    background-color: #FFFFFF;
    border: 1px solid #F1F1F190;
    box-shadow: 0px 5px 30px 0px #00266F29;
    display: flex;
    flex-direction: column;

    &:focus-visible {
        outline: none;
    }

    .header-label {
        color: #25368D;
        font-size: 24px;
        font-weight: 500;
        line-height: 35.88px;
        text-align: center;
        margin-bottom: 24px;
    }

    .label {
        color: #25368D;
        font-size: 24px;
        font-weight: 500;
        line-height: 35.88px;
        text-align: center;
        margin-bottom: 8px;
    }

    .button-container {
        margin-top: auto;
        margin-bottom: 0px;
        display: flex;
        gap: 24px;

        .button-box {
            width: 50%;
        }
    }
`;

function LocationInfoModal({
    open,
    data,
    onBack,
}) {
    function handleBack() {
        onBack && onBack();
    }

    return (
        <Modal
            className="content-center"
            open={open || false}
        >
            <Container>
                <div className="header-label" style={{ minHeight: "40px" }}>ข้อมูลสถานที่แบบสอบถาม</div>
                <div style={{ minHeight: "40px", marginBottom: '16px', overflowY: "auto" }}>
                    <div style={{ width: "100%" }}>
                        {Array.isArray(data?.ef_data) && data?.ef_data.map((value, index) => {
                            return (
                                <div key={index} style={{ width: "100%" }}>
                                    {index + 1}. {value.evaluation_name}
                                </div>
                            )
                        })}
                        {(!data?.ef_data || data?.ef_data.length === 0) &&
                            <div className="content-center" style={{ width: "100%", marginBottom: "8px" }}>
                                No Data.
                            </div>
                        }
                    </div>
                </div>
                <div className="button-container content-center">
                    <div className="button-box">
                        <ButtonComponent
                            label={"ปิด"}
                            variant={"secondary"}
                            sceenSize={"lg"}
                            style={{ maxWidth: "100%" }}
                            onClick={handleBack}
                        />
                    </div>
                </div>
            </Container>
        </Modal>
    )
}

export default LocationInfoModal;